<template>
  <div>
    <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
      <b-row class="panel-heading">
        <b-col cols="12" class="formTitleBlock">
          <h4 class="content-block labelAccordionForm" :style="'color: ' + titleColor">
            <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
            <!-- <img src='../../assets/static/images/icons/invoice.png' class="formIcon" /> -->
            {{ $t('attachments.invc_gen') }}
          </h4>
        </b-col>
        <!-- <div class="showSmallScreenOnly formTitleBlock">
          <h6 class="content-block labelAccordionForm creationFormTitle" :style="{color: titleColor}">
            <img src='../../assets/static/images/icons/invoice.png' class="formIcon" />
            {{ $t('attachments.invc_gen') }}
          </h6>
        </div> -->
        <b-col cols="12" class="content-block italicMandatoryIndication text-right">
          {{ $t('common.asterisk_obligation_label')}}
        </b-col>
      </b-row>

      <form-accordion :title="$t('common.formsSubTitle.invoice_type_e')" hasDatePicker :isTitleUpperCase="false">
        <b-row>
          <b-col sm="6" lg="6">
            <label style="width: 10cm !important"> {{ $t('common.slct_elec_invoice') }} <span class="color-red">* </span></label>
            <b-form-input list="list-format" v-model="invoiceFormat"></b-form-input>
            <b-form-datalist id="list-format" :options="sortFormatsList"></b-form-datalist>
          </b-col>
        </b-row>
      </form-accordion>

      <hr />

      <form-accordion :title="$t('common.formsSubTitle.item_info_DM')" hasDatePicker :isTitleUpperCase="false">
        <b-row class="form-group">
          <b-col sm="6" lg="6">
            <form-write-group-label-input v-model="invoiceRef" isMandatory
              :inputLabel="$t('common.invoice_reference')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" lg="6">
            <form-write-group-label-input style="width: 100% !important" v-model="dateExec" isMandatory disablePastDates
              inputType="date"
              :inputLabel="$t('common.exec_date_pay')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <hr />

      <form-accordion :title="$t('common.formsSubTitle.my_acc_info')" :isTitleUpperCase="false">
        <b-row class="form-group">
          <b-col sm="6">
            <select-bank-account v-model="sellerIBAN" :value="sellerIBAN">
            </select-bank-account>
          </b-col>
        </b-row>
      </form-accordion>

      <hr />

      <form-accordion :title="$t('common.formsSubTitle.item_info_b')" :isTitleUpperCase="false">
        <b-row class="form-group" v-if="contactSearch">
          <b-col sm="6">
            <form-contact-dropdown-label-input
              :inputLabel="$t('common.chse_b')"
              v-model="contactName"
              @change-contact="selectBuyer($event)">
            </form-contact-dropdown-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group">
          <b-col sm="6">
            <form-write-group-label-input v-model="buyerName" isMandatory
              :inputLabel="$t('common.name_social_reason')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6">
            <form-write-group-label-input v-model="buyerEmail" isMandatory
              :inputLabel="$t('common.eml')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group"  v-if="isCompanyContact">
          <b-col sm="6">
            <form-write-group-label-input v-model="buyerSiren"
              :inputLabel="$t('common.srn')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6">
            <form-write-group-label-input v-model="buyerTva"
              :inputLabel="$t('vat_id_nb')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group">
          <b-col sm="6">
            <form-write-group-label-input v-model="buyerAddress"
              :inputLabel="$t('common.adrs')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6">
            <form-write-group-label-input v-model="buyerZip"
              :inputLabel="$t('common.zp_code')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group">
          <b-col sm="6">
            <form-write-group-label-input v-model="buyerCity"
              :inputLabel="$t('common.cty')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6">
            <form-write-group-label-input v-model="buyerCountry"
              :inputLabel="$t('common.cntry')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <hr />

      <form-accordion :title="$t('common.formsSubTitle.item_info_b_b')" :isTitleUpperCase="false">
        <div>
          <b-row  style="padding-left: 15px">
            <label> {{ $t('common.fill_in_invoice_produit') }}<span class="color-red">* </span></label>
          </b-row>
          <br>
          <b-row class="form-group" v-for="(product, index) in products" :key="index">
            <b-col sm="3">
              <form-write-group-label-input v-model="product.Desc" isMandatory
                :inputLabel="$t('common.desc')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="3">
              <form-write-group-label-input v-model="product.Qte" isMandatory
                inputType="number"
                :inputLabel="$t('common.qtty')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="3">
              <form-write-group-label-input v-model="product.Amount" isMandatory
                inputType="number"
                :inputLabel="$t('common.total_price')"
                @blur="product.Amount = (Number(product.Amount)) ? Number(product.Amount).toFixed(2) : ''">
              </form-write-group-label-input>
            </b-col>
            <span class="col-1 fa fa-times-circle text-danger" style="font-size: 25px; margin-top: 30px; cursor: pointer" @click="removeProduct(index)"></span>
          </b-row>
          <b-row class="form-group">
            <b-col sm="6">
              <span style="display:flex;align-items:center;cursor: pointer" @click="addProduct()">
                <i class="fa-light fa-circle-plus" size="17px"></i>
                <i style="color:gray;margin-left: 10px;"> {{ $t('common.add_produit') }} </i>
              </span>
            </b-col>
          </b-row>
          <hr />
          <b-row class="form-group">
            <b-col sm="6">
              <form-read-group-label-input :inputValue="calculatedAmountHT" isMandatory
                inputType="number"
                :inputLabel="$t('common.amountHT')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="6">
              <form-write-group-label-input v-model="amountTVA" isMandatory
                inputType="number"
                :inputLabel="$t('common.amountTVA')"
                @blur="amountTVA = (Number(amountTVA)) ? Number(amountTVA).toFixed(2) : ''">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col sm="6">
              <form-read-group-label-input :inputValue="calculatedAmountTTC" isMandatory
                inputType="number"
                :inputLabel="$t('common.amountTTC')">
              </form-read-group-label-input>
            </b-col>
          </b-row>
        </div>
      </form-accordion>
    </div>
    <b-row class="justify-content-end">
      <b-col lg="2" cols="4">
        <b-button variant="primary" size="lg" @click="$parent.$emit('close')">
          <i class="fa-light fa-circle-xmark" size="17px"></i>
          {{ $t('common.cncl') }}
        </b-button>
      </b-col>
      <b-col lg="2" cols="4">
        <b-button variant="primary" size="lg"  @click="closeAndGenerateInvoice()" :disabled="!canGenerate">
          <i class="fa-light fa-file" size="17px"></i>
          {{ $t('common.generate') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import b64toBlob from 'b64-to-blob'
import FormAccordion from '@/components/common/FormAccordion.vue'
import FormContactDropdownLabelInput from '@/components/common/formContactDropdownLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import selectBankAccount from '@/pages/requests/components/selectBankAccount.vue'
import { errorMessageAlert } from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'DevisForm',
  components: {
    'form-accordion': FormAccordion,
    'form-contact-dropdown-label-input': FormContactDropdownLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'select-bank-account': selectBankAccount
  },
  props: {
    invoiceType: {
      type: String
    },
    propsDateExec: {
      type: String
    },
    propsSellerIBAN: {
      type: String
    },
    propsProducts: {
      type: Array,
      default: function () {
        return []
      }
    },
    buyer: {
      type: Object
    },
    propsInvoiceRef: {
      type: String
    },
    contactSearch: {
      type: Boolean,
      default: false
    },
    amountHT: {
      type: String
    },
    amountTaxes: {
      Type: String
    }
  },
  data () {
    return {
      titleColor: this.$engine.services.getServiceColor(this.$engine.user.currentService.id),
      dateExec: '',
      userType: '0',
      sellerName: '',
      sellerSiren: '',
      sellerEmail: '',
      sellerTva: '',
      sellerAddress: '',
      sellerZip: '',
      sellerCity: '',
      sellerCountry: '',
      sellerIBAN: '',
      buyerName: '',
      buyerSiren: '',
      buyerEmail: '',
      buyerTva: '',
      buyerAddress: '',
      buyerZip: '',
      buyerCity: '',
      buyerCountry: '',
      buyerIBAN: '',
      buyerAccountType: '2',
      invoiceRef: '',
      amountTVA: '',
      contactName: '',
      formats: ['FacturX', 'UN/CEFACT CII 16B', 'UBL', 'Finvoice', 'TEAPPSXML', 'e-SLOG', 'FatturaPA', 'FacturaE', 'EVS 923:2014', 'EDIFACT', 'EHF', 'E-Invoice', 'CFDI', 'ISDOC', 'E-faktura', 'OIOUBL', 'PEPPOL BIS', 'Svefaktura', 'UBL-OHNL', 'ZUGFeRD', 'Nota Fiscal Eletronica (Brazil)', 'Facturacion Eletronica (Ecuador)', 'DTE'],
      invoiceFormat: '',
      products: []
    }
  },
  created () {
    /* eslint-disable camelcase */
    var {name, email_reference, address, city, zip_code, country, identifierTVA, type, identifier} = this.$engine.user.get()
    this.userType = type
    this.sellerName = name
    this.sellerEmail = email_reference
    this.sellerAddress = address
    this.sellerCity = city
    this.sellerZip = zip_code
    this.sellerCountry = country
    this.sellerTva = identifierTVA
    if (type === '2') this.sellerSiren = identifier
    /* eslint-enable camelcase */

    /* eslint-disable no-redeclare */
    var {address, city, country, iban, identifier, name, typeContact, zipCode} = this.buyer
    this.buyerName = name
    typeContact === '2' ? this.buyerSiren = identifier : this.buyerEmail = identifier
    this.buyerAddress = address
    this.buyerZip = zipCode
    this.buyerCity = city
    this.buyerCountry = country
    this.buyerIBAN = iban
    /* eslint-enable no-redeclare */
    this.invoiceRef = this.propsInvoiceRef
    this.buyerAccountType = typeContact

    this.invoiceFormat = this.invoiceType
    this.amountTVA = this.amountTaxes
    this.dateExec = moment(this.propsDateExec, 'DD/MM/yyyy').format('yyyy-MM-DD')
    this.sellerIBAN = this.propsSellerIBAN
    this.products = this.propsProducts
  },
  mounted () {
  },
  computed: {
    sortFormatsList () {
      return this.formats.sort(
        function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase())
        }
      )
    },
    calculatedAmountHT () {
      if (this.products.length) {
        return '' + this.products.reduce((sum, val) => !val.Amount ? sum : sum + Number(val.Amount), 0).toFixed(2)
      }
      return this.amountHT
    },
    calculatedAmountTTC () {
      var amHT = Number(this.calculatedAmountHT)
      return '' + (amHT + (!this.amountTVA ? 0 : Number(this.amountTVA))).toFixed(2)
    },
    canGenerate () {
      return this.invoiceFormat && this.invoiceRef && this.dateExec && this.buyerName && this.buyerEmail && this.products.length > 0 && this.calculatedAmountHT !== undefined && this.amountTVA !== undefined && this.calculatedAmountTTC !== undefined
    },
    isCompanyContact () {
      return this.buyerAccountType !== '1'
    }
  },
  methods: {
    addProduct () {
      this.products.push({Desc: '', Qte: '', Amount: ''})
    },
    removeProduct (id) {
      this.products.splice(id, 1)
    },
    selectBuyer (buyer) {
      let {address, city, zipCode, country, identifier, name, typeContact, iban} = buyer
      let email = typeContact === '1' ? identifier : ''
      let siren = typeContact === '2' ? identifier : ''
      if (name !== undefined) {
        this.buyerAddress = address
        this.buyerCity = city
        this.buyerZip = zipCode
        this.buyerCountry = country
        this.buyerName = name
        this.buyerEmail = email
        this.buyerSiren = siren
        this.buyerIBAN = iban
        this.buyerAccountType = typeContact
      }
    },
    generateInvoice () {
      let payload = {
        CreditorName: this.sellerName,
        CreditorMail: this.sellerEmail,
        CreditorAddress: this.sellerAddress,
        CreditorZip: this.sellerZip,
        CreditorCity: this.sellerCity,
        CreditorCountryCode: 'FR',
        CreditorSiren: this.sellerSiren,
        CreditorNumFiscal: this.sellerTva,
        DebtorName: this.buyerName,
        DebtorMail: this.buyerEmail,
        DebtorAddress: this.buyerAddress,
        DebtorZip: this.buyerZip,
        DebtorCity: this.buyerCity,
        DebtorCountryCode: 'FR',
        DebtorSiren: this.buyerSiren,
        DebtorNumFiscal: this.buyerTva,
        InvoiceReference: this.invoiceRef,
        CreditorIban: 'FR83145080007036INESRYDER08',
        AmountHT: this.amountHT,
        AmountTVA: this.amountTVA,
        AmountTTC: this.amountTTC,
        ProcessProfileID: this.invoiceRef,
        GuidelineProfileID: 'urn:cen.eu:en16931:2017',
        ExecutionDate: this.dateExec
      }

      let that = this

      this.$f7.showPreloader('Génération du devis en cours')
      this.$engine.services.generateFacturx(payload)
      .then(response => {
        that.$f7.hidePreloader()
        if (response.status === 200) {
          if (response.status === 300) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: 'Devis généré',
              text: '<i class="fa-light fa-check" size="17px"></i>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/home/'})
            }, 2000)
          }

          this.$f7.modal({
            title: this.$t('Devis généré'),
            text: '<p> Voulez-vous télécharger le devis sous format pdf ? </p>',
            afterText: '',
            buttons: [
              {
                text: 'Oui',
                onClick: function () {
                  // Download PDF
                  let { DocumentName, DocumentData } = response.data
                  let blob = b64toBlob(DocumentData.split(',')[1], DocumentData.split(';')[0].replace(/^data:/, ''))
                  let url = window.URL.createObjectURL(blob)
                  let fileLink = document.createElement('a')
                  fileLink.href = url
                  fileLink.setAttribute('download', DocumentName) // or any other extension
                  fileLink.click()

                  setTimeout(function () { loadPage(that, {url: '/home/'}) }, 500)
                }
              },
              {
                text: 'Non',
                onClick: function () {
                  that.$f7.closeModal()
                  loadPage(that, {url: '/home/'})
                }
              }
            ]
          })
        }
      })
      .catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that)
      })
    },
    closeAndGenerateInvoice () {
      this.$parent.$emit('close')
      let payload = {
        DebtorName: this.buyerName,
        DebtorFirmName: this.buyerName,
        DebtorMail: this.buyerEmail,
        DebtorAddress: this.buyerAddress,
        DebtorZip: this.buyerZip,
        DebtorCity: this.buyerCity,
        DebtorCountry: this.buyerCountry,
        DebtorCountryCode: 'FR',
        DebtorSiren: this.buyerSiren,
        DebtorNumFiscal: this.buyerTva,
        DebtorIban: this.buyerIBAN,
        InvoiceReference: this.invoiceRef,
        CreditorIban: this.sellerIBAN,
        AmountHT: this.calculatedAmountHT,
        AmountTVA: this.amountTVA,
        AmountTTC: this.calculatedAmountTTC,
        ProcessProfileID: this.invoiceRef,
        GuidelineProfileID: 'urn:cen.eu:en16931:2017',
        ExecutionDate: this.dateExec,
        DocumentTypeCode: '741',
        Currency: 'EUR',
        Items: this.products
      }
      this.$bus.$emit('close-popup-generate-invoice', payload)
    }
  }
}
</script>
